import type { Dict } from "../types";

export const subscription: Dict = {
  en: {

    // SubscriptionStatusBanner
    "SubscriptionStatus.error": "Error",
    "SubscriptionStatus.failedToOpen": "Failed to open subscription management. Please try again.",
    "SubscriptionStatus.accountSuspended": "Account Suspended: Payment Failed",
    "SubscriptionStatus.suspendedDescription":
      "Your account has been suspended due to payment failure. Please update your payment method immediately to restore access.",
    "SubscriptionStatus.updatePayment": "Update Payment",
    "SubscriptionStatus.paymentIssue": "Payment Issue Detected",
    "SubscriptionStatus.paymentIssueDescription":
      "We couldn't process your recent payment (Attempt {count}/3). Please update your payment method to avoid service interruption.",
    "SubscriptionStatus.cancellationScheduled": "Subscription Cancellation Scheduled",
    "SubscriptionStatus.cancellationDescription": "Your {tier} subscription will be cancelled on {date}. You retain full access until then.",
    "SubscriptionStatus.reactivate": "Reactivate",

    // Subscription Limits
    "Limits.title": "Subscription Limits",
    "Limits.owners": "Owners",
    "Limits.locations": "Locations",
    "Limits.hairdressers": "Employees",
    "Limits.employees": "Employees",
    "Limits.seatsAdjusted": "{plan} with your plan, {effective} for your salon",
    "Limits.locationsAdjusted": "{plan} with your plan, {effective} for your salon",
    "Limits.campaigns": "Email campaigns",
    "Limits.smsSent": "SMS sent",
    "Limits.smsOverageHint": "then {cents}¢ / SMS over quota",
    "Limits.aiMinutes": "AI minutes",
    "Limits.aiMinutesHint": "$0.35 / minute · no cutoff",
    "Limits.thisMonth": "this month",
    "Limits.limitReached": "Limit Reached",
    "Limits.upgradePrompt": "Upgrade your plan to add more",
    "Limits.salonLimitPrompt": "This limit was set for your salon. Contact Flowcut support to raise it.",
  },
  fr: {

    // SubscriptionStatusBanner
    "SubscriptionStatus.error": "Erreur",
    "SubscriptionStatus.failedToOpen": "Impossible d'ouvrir la gestion de l'abonnement. Veuillez réessayer.",
    "SubscriptionStatus.accountSuspended": "Compte suspendu : échec du paiement",
    "SubscriptionStatus.suspendedDescription":
      "Votre compte a été suspendu en raison d'un échec de paiement. Veuillez mettre à jour votre méthode de paiement immédiatement pour rétablir l'accès.",
    "SubscriptionStatus.updatePayment": "Mettre à jour le paiement",
    "SubscriptionStatus.paymentIssue": "Problème de paiement détecté",
    "SubscriptionStatus.paymentIssueDescription":
      "Nous n'avons pas pu traiter votre dernier paiement (tentative {count}/3). Veuillez mettre à jour votre méthode de paiement pour éviter une interruption de service.",
    "SubscriptionStatus.cancellationScheduled": "Annulation d'abonnement programmée",
    "SubscriptionStatus.cancellationDescription": "Votre abonnement {tier} sera annulé le {date}. Vous conservez l'accès complet jusqu'à cette date.",
    "SubscriptionStatus.reactivate": "Réactiver",

    // Limites d'abonnement
    "Limits.title": "Limites d'abonnement",
    "Limits.owners": "Propriétaires",
    "Limits.locations": "Emplacements",
    "Limits.hairdressers": "Employés",
    "Limits.employees": "Employés",
    "Limits.seatsAdjusted": "{plan} avec votre forfait, {effective} pour votre salon",
    "Limits.locationsAdjusted": "{plan} avec votre forfait, {effective} pour votre salon",
    "Limits.campaigns": "Campagnes courriel",
    "Limits.smsSent": "SMS envoyés",
    "Limits.smsOverageHint": "puis {cents}¢ / SMS au-delà",
    "Limits.aiMinutes": "Minutes IA",
    "Limits.aiMinutesHint": "0,35 $ / minute · aucune coupure",
    "Limits.thisMonth": "ce mois-ci",
    "Limits.limitReached": "Limite atteinte",
    "Limits.upgradePrompt": "Améliorez votre plan pour en ajouter plus",
    "Limits.salonLimitPrompt": "Cette limite a été fixée pour votre salon. Contactez le soutien Flowcut pour l'augmenter.",
  },
};
